
import { Election } from '../models/vote';

export function getElectionType(type: Election['typeVote']){
  if (type === 'book') return "Livro"
  else if (type === 'meet') return "Encontro"

  return ""
}